export default "__VITE_ASSET__42724b02__"